import React, { useState } from 'react';
import { Text, Title, TitleProps } from '@gjensidige/builders-components';
import { useAppSelector } from '../../../hooks/appHooks';
import { PRODUCTS } from '../../../lib/constants/appConstants';
import './InsuranceTileHeader.scss';
import { Package } from '../../../interfaces/Types';
import { AppConstants } from '../../../utils/AppConstants';
import { InformationModal } from '../../Common/InformationModal/InformationModal';
import { TextHelper } from '../../../utils/TextHelper';

interface Props {
  data: Package;
  priceLabel: string;
  oldPriceLabel: string;
  packageTitle: string;
  additionalInfos: string[];
  //shouldDisplayAddOnPlusSign?: boolean;
  /**
   * Handle side effects of updating the Tile selection
   */
  updateTileSelection: (selectedTile: any) => void;
}

export type ComponentProps = Props;

const InsuranceTileHeader: React.FC<ComponentProps> = (props) => {
  const [isRecommendedModalOpen, setRecommendedModalOpen] = useState(false);

  const updatePackageSelection = () => {
    props.updateTileSelection(props.data);
  };
  const productName = useAppSelector(
    (state) => state.insurance.offer.productName
  );

  //TODO : Move this logic to container and pass only props
  const returnClassName = () => {
    let generatedClassName = 'tile-header';
    if (props.data.isPlusPackage) {
      generatedClassName = 'pluspacket-section';
    }

    if (!props.data.isEnabled) {
      generatedClassName += ' disabled-tile';
    }
    return generatedClassName;
  };

  return (
    <>
      <div>
        <div className="tile-container-div">
          <div className={returnClassName()}>
            <div
              className="pluspacket-wrapper package-info-wrapper"
            >
              <>
                <Title
                  as={"h3" as TitleProps['as']}
                  size="5"
                  className="pakage-header-label"
                >
                  {props.packageTitle}
                </Title>
              </>
              <div className="package-price-wrapper">
                  <div className="package-price-section">
                    {/* <Title
                      as="h4"
                      className="pakage-header-label no-line-break d-none d-xl-block"
                    >
                      {props.data.monthlyPrice
                        ? `${TextHelper.thousandSeparator(props.data.monthlyPrice)} ${props.data.currency}`
                        : '-'}
                    </Title> */}
                    <Text
                      size="large"
                      weight="700"
                      className="pakage-header-label no-line-break"
                    >
                      {props.data.monthlyPrice
                        ? `${TextHelper.thousandSeparator(props.data.monthlyPrice)} ${props.data.currency}`
                        : '-'}
                    </Text>
                    {props.data.monthlyPrice && (
                      <Text  size="small" className="pakage-header-label package-currency-label">{`/ mån`}</Text>
                    )}
                  </div>
              </div>
              {props.oldPriceLabel && (
                <Text
                  className={`pakage-header-label striked-pakage-price-label ${
                    !props.data.monthlyPrice ? 'hidden' : ''
                  }`}
                >
                  {props.oldPriceLabel}
                </Text>
              )}
              {props.additionalInfos?.map((info: string, index: number) => {
                if (info) {
                  return (
                    <div
                      className="additional-info-label pakage-header-label"
                      key={index}
                    >
                      {info}
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default InsuranceTileHeader;
